import { render, staticRenderFns } from "./NewMatrixCourse.vue?vue&type=template&id=4b628721&"
import script from "./NewMatrixCourse.vue?vue&type=script&lang=js&"
export * from "./NewMatrixCourse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports